import { Pasuk } from '../../data/psukim';

export const bookNumberMap: any = {
  Bereshit: '1',
  Shemot: '2',
  Vayikra: '3',
  Bamidbar: '4',
  Devarim: '5',
};

/**
 * Path segments for a rabbi audio/alignment file. Torah books (parasha) keep the
 * original casing of nusach/rabiKey and map the book to its number (1-5); haftara
 * books (e.g. "Isaiah") use lowercased segments to fit the haftara file naming.
 */
const rabbiFilePath = (pasuk: Pasuk, nusach: string, rabiKey: string): string => {
  const torahBookNumber = bookNumberMap[pasuk.book];
  if (torahBookNumber) {
    return `${nusach}/${rabiKey}/${torahBookNumber}_${pasuk.chapter}_${pasuk.pasuk}`;
  }
  const haftaraBookSlug = pasuk.book.toLowerCase().replace(/\s+/g, '_');
  return `${nusach.toLowerCase()}/${rabiKey.toLowerCase()}/${haftaraBookSlug}_${pasuk.chapter}_${pasuk.pasuk}`;
};

export const getRabbiAudioUrl = (pasuk?: Pasuk, nusach = 'ashkenaz', rabiKey = 'gal_levy') => {
  if (!pasuk) return '';
  return `https://d1q1chclchjxl4.cloudfront.net/audio_rabi/${rabbiFilePath(pasuk, nusach, rabiKey)}.mp3`;
};

export const getRabbiAlignmentJsonUrl = (
  pasuk?: Pasuk,
  nusach = 'ashkenaz',
  rabiKey = 'gal_levy',
) => {
  if (!pasuk) return '';
  return `https://d1q1chclchjxl4.cloudfront.net/audio_rabi/${rabbiFilePath(pasuk, nusach, rabiKey)}.json`;
};

export type RabbiSpecialAudioType =
  | 'shema'
  | 'birchot_hatorah'
  | 'birchot_hatorah_before'
  | 'birchot_hatorah_after';

export const getRabbiSpecialAudioUrl = (
  type: RabbiSpecialAudioType,
  nusach = 'ashkenaz',
  rabbiKey = 'gal_levy',
): string => {
  return `https://d1q1chclchjxl4.cloudfront.net/audio_rabi/${nusach}/${rabbiKey}/${type}.mp3`;
};

export const getRabbiSpecialAlignmentJsonUrl = (
  type: RabbiSpecialAudioType,
  nusach = 'ashkenaz',
  rabbiKey = 'gal_levy',
): string => {
  return `https://d1q1chclchjxl4.cloudfront.net/audio_rabi/${nusach}/${rabbiKey}/${type}.json`;
};
